export default __webpack_public_path__ + "locales/it/OAuth.json?hash=4e1cac52bbb1246ac77a80dc0cb0eacf";